import { render } from "./gatsby.vue?vue&type=template&id=dfdbeadc"
import script from "./gatsby.vue?vue&type=script&lang=js"
export * from "./gatsby.vue?vue&type=script&lang=js"

import "./gatsby.vue?vue&type=style&index=0&id=dfdbeadc&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__